import { getLogger } from '@logtape/logtape';
import useSWRImmutable from 'swr/immutable';

import { SelectionOption } from '@/models/SelectionOption.ts';

import { fetchDcInstanceRoles } from '@/services/dc-role-service.ts';

const logger = getLogger(['hook', 'dc-roles']);

interface UseDcRolesReturn {
    roles: SelectionOption[];
}

const fetchDcRoleOptions = async (instanceIds: string[]): Promise<SelectionOption[]> => {
    const results = await Promise.all(instanceIds.map((id) => fetchDcInstanceRoles(id)));

    const uniqueByValue = new Map<string, SelectionOption>();
    for (const instanceRoles of results) {
        for (const role of instanceRoles) {
            if (role.value) {
                uniqueByValue.set(role.value, { value: role.value, label: role.value });
            }
        }
    }

    return [...uniqueByValue.values()].sort((a, b) => a.label.localeCompare(b.label));
};

export const useDcRoles = (instanceIds: string[]): UseDcRolesReturn => {
    const key =
        instanceIds.length > 0 ? ['dc-roles', ...[...instanceIds].sort((a, b) => a.localeCompare(b))] : undefined;

    const { data } = useSWRImmutable(key, () => fetchDcRoleOptions(instanceIds), {
        onError: (error: Error): void => {
            logger.error('Failed to fetch DC roles', { error: error });
        },
    });

    return { roles: data ?? [] };
};
